import React, { PureComponent } from 'react';

const PARTICLE_COUNT = 40;

class FireAnimation extends PureComponent {
    constructor(props) {
        super(props);
        this.particles = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
            id: i,
            left: 20 + Math.random() * 60,
            delay: Math.random() * 0.8,
            duration: 1.5 + Math.random() * 1,
            size: 10 + Math.random() * 20,
            hue: Math.floor(Math.random() * 40),
        }));
    }

    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                {this.particles.map(p => (
                    <div
                        key={p.id}
                        style={{
                            ...styles.particle,
                            left: `${p.left}%`,
                            width: p.size,
                            height: p.size * 1.5,
                            animationDelay: `${p.delay}s`,
                            animationDuration: `${p.duration}s`,
                            background: `radial-gradient(ellipse, hsl(${p.hue}, 100%, 60%), hsl(${p.hue}, 100%, 40%), transparent)`,
                        }}
                    />
                ))}
                <div style={styles.glow} />
            </div>
        );
    }
}

const keyframes = `
@keyframes fire-rise {
    0% { transform: translateY(0) scale(1); opacity: 0.9; }
    50% { opacity: 0.7; }
    100% { transform: translateY(-60vh) scale(0.3); opacity: 0; }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
    },
    particle: {
        position: 'absolute',
        bottom: -20,
        borderRadius: '50%',
        filter: 'blur(3px)',
        animation: 'fire-rise ease-out forwards',
    },
    glow: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30%',
        background: 'linear-gradient(to top, rgba(255, 80, 0, 0.15), transparent)',
        pointerEvents: 'none',
    },
};

export default FireAnimation;
